// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { File as RawFile } from "lucide-react";
export const File = /* @__PURE__ */ createIcon(RawFile, "File", 2);
